import {
  ScheduleItem as ScheduleItemAmbassador,
  ScheduleStatus,
} from '@wix/ambassador-events-schedule-v1-schedule-item/types'
import {ScheduleTag} from './services/schedule'

export const ALL_LOCATIONS = 'ALL_LOCATIONS'

export interface ScheduleItem {
  formattedDuration: string
  formattedTimeSlot: string
  formattedUpdatedDate: string
  name: string
  description: string
  tags: ScheduleTag[]
  location: string
  id: string
  status: ScheduleStatus
  bookmarked: boolean
}

export interface ScheduleDays {
  [key: string]: {
    title: string
    items: ScheduleItem[]
  }
}

export interface ScheduleItemResponse extends ScheduleItemAmbassador {
  formattedDuration: string
  formattedTime: string
  formattedUpdatedDate: string
  key: string
  shortDate: string
  bookmarked?: boolean
}
